import React, { useRef } from "react";
import { PortalContext } from "../../../context/Provider";
import { useContext } from "react";
import "./CardInforme.css";
import { hideModal, showModal } from "../../../context/Actions/modal/modal";
import {
  informePDFReset,
  visulizadorReset,
  wsGetInformePDF,
  wsGetMisInformesImagen,
} from "../../../context/Actions/misInformes/misInformes";
import { showToaster } from "../../../../global/context/action/toaster/toaster";

import { Filesystem, Directory } from "@capacitor/filesystem";
import camelize from "../../../../global/utils/camelize";
import { detectarIOS } from "../../../../global/utils/detectarIOS";
import { detectarNavegador } from "../../../../global/utils/detectarNavegador";
import DescargarIcon from "../../../assets/images/generico/DescargarIcon";
import PdfIcon from "../../../assets/images/generico/PdfIcon";
import { FileOpener } from "@capacitor-community/file-opener";
import EnviarMailIcon from "../../../assets/images/generico/EnviarMailIcon";
import Tooltip from "../../../../global/component/Genericos/Tooltip/Tooltip";
import { GlobalContext } from "global/context/Provider";
import { getStrDateYear } from "global/utils/diasData";
import TildeIcon from "_+_Portal/assets/images/generico/TildeIcon";
import AlertIcon from "_+_Portal/assets/images/generico/AlertIcon";
import WarningIcon from "_+_Portal/assets/images/generico/WarningIcon";
import { Device } from "@capacitor/device";
import { isMobile } from "react-device-detect";
import ShowPassIcon from "_+_Portal/_-_SegundoFactor/assets/ShowPassIcon";
import { detecIosNew } from "global/utils/detecIosNew";

import { Browser } from "@capacitor/browser";
import { Capacitor } from "@capacitor/core";

const CardInforme = ({ item }) => {
  const {
    modalDispatch,
    misInformesState,
    misInformesDispatch,
    selectDropDownState,
  } = useContext(PortalContext);
  const { authState, toasterDispatch, configState } = useContext(GlobalContext);
  const fechaHoy = new Date();
  const ua = navigator.userAgent || "";

  const downloadiOSFileNative = (base64Data) => {
    const b64Data = base64Data;
    const fileName = `Informe-${item.idturno}.pdf`;
    Filesystem.writeFile({
      path: fileName,
      data: b64Data,
      directory: Directory.Documents,
    }).then((c) => {
      const rutaGuardado = c.uri;
      try {
        const fileOpenerOptions = {
          filePath: rutaGuardado,
          contentType: "application/pdf",
          openWithDefault: true,
        };
        FileOpener.open(fileOpenerOptions);
      } catch (e) {
        console.log("Error opening file", e);
      }
    });
  };

  //necesario para el sdk actual
  const currentDate = new Date().toLocaleString().replace(/[,:\s/]/g, "-");
  const downloadPdfAndroidNative = (base64Data) => {
    const b64Data = base64Data;
    const fileName = `Informe-${currentDate}.pdf`;
    Filesystem.writeFile({
      path: `Download/${fileName}`,
      data: b64Data,
      directory: Directory.ExternalStorage,
    }).then((c) => {
      const rutaGuardado = c.uri;
      try {
        const fileOpenerOptions = {
          filePath: rutaGuardado,
          contentType: "application/pdf",
          openWithDefault: true,
        };
        FileOpener.open(fileOpenerOptions);
      } catch (e) {
        console.log("Error opening file", e);
      }
    });
  };

  const blobToBase64 = (blob) =>
    new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onloadend = () => {
        const result = reader.result || "";
        const base64 = result.toString().split(",")[1] || "";
        resolve(base64);
      };
      reader.onerror = reject;
      reader.readAsDataURL(blob);
    });

  const trackButton = useRef();

  const dissmiss = () => {
    hideModal()(modalDispatch);
    informePDFReset()(misInformesDispatch);
  };

  const modalAvisoNavegador = () => {
    showModal(
      "Genericos/DeteccionNavegador/DeteccionNavegador",
      {},
      [],
      "centro",
      false
    )(modalDispatch);
  };

  const informePdf = (tipo, estudio, codigo) => {
    wsGetInformePDF(tipo, estudio, codigo, verPDF)(misInformesDispatch);
  };

  const verPDF = (isCorrect, data) => {
    if (isCorrect) {
      showModal(
        "Genericos/InformePDF/InformePDF",
        {
          titulo: `Informe: ${camelize(item.tipo_desc)}`,
          dissmiss: dissmiss,
          blob: data?.blob,
        },
        [],
        "centro",
        true
      )(modalDispatch);
    } else {
      showToaster(
        {
          texto: data
            ? data
            : "En este momento no se puede ver/descargar el informe",
          tipo: "danger",
        },
        "centroArriba"
      )(toasterDispatch);
      hideModal()(modalDispatch);
    }
  };

  const modalInformePdf = (tipo, estudio, codigo) => {
    const sBrowser = detectarNavegador();
    const isIOS = detectarIOS();
    if (isIOS) {
      if (sBrowser !== "GoogleChrome") {
        informePdf(tipo, estudio, codigo);
      } else {
        modalAvisoNavegador();
      }
    } else {
      informePdf(tipo, estudio, codigo);
    }
  };

  // const visualizarInforme = (idturno) => {
  //   // Abrimos una ventana en blanco de una (Safari lo permite si es desde el onClick)
  //   const newWindow = window.open("", "_blank");

  //   // Si no se pudo abrir (pop-up bloqueado), avisamos
  //   if (!newWindow) {
  //     showToaster(
  //       {
  //         texto: "Debes habilitar las ventanas emergentes en tu navegador.",
  //         tipo: "danger",
  //       },
  //       "centroArriba"
  //     )(toasterDispatch);
  //     return;
  //   }

  //   wsGetMisInformesImagen(
  //     configState?.config?.data?.opcImagenPacsNEW,
  //     idturno,
  //     isMobile,
  //     async (isCorrect, data) => {
  //       if (isCorrect) {
  //         if (data === "") {
  //           showToaster(
  //             {
  //               texto: "No se encontró imagen para visualizar",
  //               tipo: "danger",
  //             },
  //             "centroArriba"
  //           )(toasterDispatch);
  //           newWindow.close();
  //           return;
  //         } else {
  //           const { isIOS, isStandalone } = detecIosNew();

  //           if (Capacitor.isNativePlatform()) {
  //             // Aplicaciones nativas (Android/iOS)
  //             await Browser.open({ url: data });
  //           } else {
  //             if (isIOS && isStandalone) {
  //               // Modo standalone en iOS
  //               const descarga = document.createElement("a");
  //               descarga.href = misInformesState.misInformes.visualizarimagen;
  //               descarga.rel = "noopener";
  //               document.body.appendChild(descarga);
  //               descarga.click();
  //               document.body.removeChild(descarga);
  //               visulizadorReset()(misInformesDispatch);
  //             } else {
  //               newWindow.location.href = data;
  //             }
  //           }
  //         }
  //       } else {
  //         showToaster(
  //           {
  //             texto: "No se encontró imagen para visualizar",
  //             tipo: "danger",
  //           },
  //           "centroArriba"
  //         )(toasterDispatch);
  //         newWindow.close();
  //       }
  //     }
  //   )(misInformesDispatch);
  // };

  const visualizarInforme = (idturno) => {
    // Creamos la nueva ventana antes de hacer nada asíncrono
    let newWindow = null;

    if (!Capacitor.isNativePlatform()) {
      newWindow = window.open("", "_blank");
    }

    wsGetMisInformesImagen(
      configState?.config?.data?.opcImagenPacsNEW,
      idturno,
      isMobile,
      async (isCorrect, data) => {
        if (!isCorrect || data.url === "") {
          showToaster(
            {
              texto: "No se encontró imagen para visualizar",
              tipo: "danger",
            },
            "centroArriba"
          )(toasterDispatch);

          if (newWindow) newWindow.close();
          return;
        }

        const { isIOS, isStandalone } = detecIosNew();

        if (Capacitor.isNativePlatform()) {
          // ✅ En app nativa
          await Browser.open({ url: data.url });
        } else {
          // ✅ En navegador web (Safari, Chrome, etc)
          if (!newWindow) {
            showToaster(
              {
                texto:
                  "Debes habilitar las ventanas emergentes en tu navegador.",
                tipo: "danger",
              },
              "centroArriba"
            )(toasterDispatch);
            return;
          }

          // Actualizamos la URL después de recibir los datos
          if (isIOS && isStandalone) {
            const descarga = document.createElement("a");
            descarga.href = data.url;
            descarga.rel = "noopener";
            document.body.appendChild(descarga);
            descarga.click();
            document.body.removeChild(descarga);
          } else {
            newWindow.location.href = data.url;
          }
        }
      }
    )(misInformesDispatch);
  };

  const enviarInformePorMail = () => {
    const { pacienteElegido } = selectDropDownState.selectDropDown.selectGlobal;
    showModal(
      "Genericos/EnviarMailModal/EnviarMailModal",
      {
        paciente: pacienteElegido
          ? pacienteElegido.paciente
          : authState.auth.data.paciente,
        idturno: item.idturno,
        tipo: item.tipo,
        codigo: item.codigo,
        estudio: item.estudio,
      },
      {},
      "centro",
      true
    )(modalDispatch);
  };

  const descargarPDF = (tipo, estudio, codigo) => {
    const sBrowser = detectarNavegador();
    const isIOS = detectarIOS();
    if (isIOS) {
      if (sBrowser !== "GoogleChrome") {
        wsGetInformePDF(tipo, estudio, codigo, crearPDF)(misInformesDispatch);
      } else {
        modalAvisoNavegador();
      }
    } else {
      wsGetInformePDF(tipo, estudio, codigo, crearPDF)(misInformesDispatch);
    }
  };

  const crearPDF = async (isCorrect, data) => {
    if (isCorrect) {
      const { blob } = data || {};
      const isIOS = detectarIOS();
      if (isIOS) {
        Device.getInfo().then(async (info) => {
          if (info.platform === "web") {
            const objectUrl = URL.createObjectURL(blob);
            const descarga = document.createElement(`a`);
            descarga.href = objectUrl;
            descarga.target = "_blank";
            descarga.download = `Informe-${item.idturno}.pdf`;
            document.body.appendChild(descarga);
            descarga.click();
            document.body.removeChild(descarga);
            URL.revokeObjectURL(objectUrl);
          } else {
            const b64Data = await blobToBase64(blob);
            downloadiOSFileNative(b64Data);
          }
        });
      } else {
        Device.getInfo().then(async (info) => {
          const isGoogleAppWebView = /GSA/.test(ua);
          if (isGoogleAppWebView) {
            const b64Data = await blobToBase64(blob);
            const url = `data:application/pdf;base64,${b64Data}`;
            window.open(url, "_blank");
          } else {
            if (info.platform === "web") {
              const objectUrl = URL.createObjectURL(blob);
              const descarga = document.createElement("a");
              descarga.href = objectUrl;
              descarga.target = "_blank";
              descarga.download = `Informe-${item.idturno}.pdf`;
              document.body.appendChild(descarga);
              descarga.click();
              document.body.removeChild(descarga);
              URL.revokeObjectURL(objectUrl);
            } else {
              const b64Data = await blobToBase64(blob);
              downloadPdfAndroidNative(b64Data);
            }
          }
        });
      }
      informePDFReset()(misInformesDispatch);
    } else {
      showToaster(
        {
          texto: data ? data : "Error al descargar PDF",
          tipo: "danger",
        },
        "centroArriba"
      )(toasterDispatch);
    }
  };

  return (
    <React.Fragment>
      <div ref={trackButton}>
        <div className="ptur-misInformes-card" ref={trackButton}>
          <div
            className={
              item.pendiente && fechaHoy < new Date(item.fechaentrega)
                ? "ptur-misInformes-tituloPendiente"
                : "ptur-misInformes-titulo"
            }
          >
            <p className="rb18b">{camelize(item.tipo_desc)}</p>
          </div>
          <div className="ptur-misInformes-card-cuerpo">
            <p className="ptur-misInformes-turnoSolicitado rb18l">
              Médico:{" "}
              <span className="rb18b">{camelize(item.medico_desc)}</span>
            </p>
            <p className="ptur-misInformes-turnoSolicitado rb18l">
              Fecha de entrega:{" "}
              <span className="rb18b">
                {new Date(item.fechaentrega).toLocaleDateString("es-AR", {
                  day: "2-digit",
                  month: "2-digit",
                  year: "2-digit",
                })}
              </span>
            </p>
          </div>

          {item.pendiente ? (
            <div className="ptur-misInformes-lineaDeTiempo-container">
              <hr className="ptur-misInformes-lineaDeTiempo" />
              <div className="ptur-misInformes-puntos-container">
                <div className="ptur-misInformes-punto-texto">
                  <div className="misInformes-texto-linea">
                    <p className="ptur-misInformes-texto rb12l">
                      Día de atención
                    </p>
                    <p className="ptur-misInformes-texto rb12b">
                      {getStrDateYear(new Date(item.fecha))}
                    </p>
                  </div>
                  <div className="ptur-misInformes-punto" />
                </div>

                {fechaHoy < new Date(item.fechaentrega) ? (
                  <>
                    <div className="ptur-misInformes-punto-texto2">
                      <div className="misInformes-texto-linea">
                        <p className="ptur-misInformes-texto rb12l">Hoy</p>
                        <p className="ptur-misInformes-texto rb12b">
                          {getStrDateYear(new Date())}
                        </p>
                      </div>
                      <div className="ptur-misInformes-punto" />
                    </div>
                    <div className="ptur-misInformes-punto-texto3">
                      <div className="misInformes-texto-linea">
                        <p className="ptur-misInformes-texto rb12l">
                          Fecha de entrega
                        </p>
                        <p className="ptur-misInformes-texto rb12b">
                          {getStrDateYear(new Date(item.fechaentrega))}
                        </p>
                      </div>
                      <div className="ptur-misInformes-punto" />
                    </div>
                  </>
                ) : (
                  <>
                    <div className="ptur-misInformes-punto-texto2">
                      <div className="misInformes-texto-linea">
                        <p className="ptur-misInformes-texto rb12l">
                          Fecha de entrega
                        </p>
                        <p className="ptur-misInformes-texto rb12b">
                          {getStrDateYear(new Date(item.fechaentrega))}
                        </p>
                      </div>
                      <div className="ptur-misInformes-punto" />
                    </div>
                    <div className="ptur-misInformes-punto-texto3">
                      <div className="misInformes-texto-linea-fin">
                        <p className="ptur-misInformes-texto rb12l">Hoy</p>
                        <p className="ptur-misInformes-texto rb12b">
                          {getStrDateYear(new Date())}
                        </p>
                      </div>
                      <div className="ptur-misInformes-punto" />
                    </div>
                  </>
                )}
              </div>
            </div>
          ) : (
            ""
          )}

          {!item.pendiente && <hr className="ptur-misInformes-separador" />}
          {item.pendiente ? (
            <div className="ptur-misInformes-resultados">
              {fechaHoy < new Date(item.fechaentrega) ? (
                <>
                  <span className="ptur-misInformes-incompleto">
                    <AlertIcon color={"#FF6600"} />
                  </span>
                  <p className="rb14m ptur-misInformes-incompleto-texto">
                    Tu informe está pendiente
                  </p>
                </>
              ) : (
                <>
                  <span className="ptur-misInformes-alerta">
                    <WarningIcon color="var(--color-danger)" />
                  </span>
                  <p className="rb14m ptur-misInformes-alerta-texto">
                    Estamos demorados con la entrega
                  </p>
                </>
              )}
            </div>
          ) : (
            <>
              <div className="ptur-misInformes-cajas-estudio-visualizar">
                <div className="ptur-misInformes-iconosSmallContainer">
                  <Tooltip
                    customCss={"ptur-misInformes-verEstudio-tooltip"}
                    descripcion={"Ver informe"}
                    data={
                      <div
                        className="ptur-misInformes-verEstudio rb16m c-latex30"
                        onClick={
                          typeof window.orientation !== "undefined"
                            ? () =>
                                descargarPDF(
                                  item.tipo,
                                  item.estudio,
                                  item.codigo
                                )
                            : () =>
                                modalInformePdf(
                                  item.tipo,
                                  item.estudio,
                                  item.codigo
                                )
                        }
                      >
                        <PdfIcon />
                      </div>
                    }
                  />
                  <Tooltip
                    customCss={"ptur-misInformes-descargarEstudio-tooltip"}
                    descripcion={"Descargar informe"}
                    data={
                      <div
                        className="ptur-misInformes-iconoCompartir"
                        onClick={() =>
                          descargarPDF(item.tipo, item.estudio, item.codigo)
                        }
                      >
                        <DescargarIcon
                          color="var(--color-latex30)"
                          width={20}
                          height={20}
                        />
                      </div>
                    }
                  />
                  <Tooltip
                    customCss={"ptur-misInformes-enviarEstudio-tooltip"}
                    descripcion={"Enviar informe por email"}
                    data={
                      <div
                        className="ptur-misInformes-iconoCompartir"
                        onClick={() => enviarInformePorMail()}
                      >
                        <EnviarMailIcon
                          color="var(--color-latex30)"
                          width={20}
                        />
                      </div>
                    }
                  />
                </div>
                <Tooltip
                  customCss={"ptur-misInformes-verImagenEstudio-tooltip"}
                  descripcion={"Ver imagen del estudio"}
                  data={
                    item.tieneImagen && (
                      <div
                        className="ptur-misInformes-visualizar"
                        onClick={() => visualizarInforme(item.idturno)}
                      >
                        <ShowPassIcon color="var(--color-latex30)" />
                        <span className="rb16m c-latex30 bgc-white">
                          Imagen
                        </span>
                      </div>
                    )
                  }
                />
              </div>
              <div className="ptur-misInformes-resultados">
                <span className="ptur-misInformes-tilde">
                  <TildeIcon color={"var(--color-broccoli)"} />
                </span>
                <p className="rb14m ptur-misInformes-tilde-texto">
                  Tus resultados están completos
                </p>
              </div>
            </>
          )}
        </div>
      </div>
    </React.Fragment>
  );
};

export default CardInforme;
